import { useState } from 'react';
import './style.scss';
import { IdHelper } from '../../../../../../helpers/id.helper';
import type { ITicketSuggestion } from '../../../../../../models/ticket-suggestion.model';
import type { IJourney } from '../../../../../../models/journey.model';
import { TranslationService } from '../../../../../../services/translation.service';
import TicketSuggestions from '../../../../../Shared/TicketSuggestions';
import { TransportMode } from '../../../../../../models/transport-mode.enum';
import { TravellerCategory } from '../../../../../../models/traveller-category.enum';
import { ProductType } from '../../../../../../models/product-type.enum';
import type { IJourneyDetails } from '../../../../../../models/journey-details.model';
import ZoneIcon from './components/ZoneIcon';
import { AnalyticsService } from '../../../../../../services/analytics-service';
import { TicketSuggestionHelper } from '../../../../../../helpers/ticket-suggestion.helper';

function getCheapestSingleTicket(ticketSuggestions: ITicketSuggestion[] | undefined, selectedTravellerCategory: TravellerCategory): ITicketSuggestion | undefined {
  if (!ticketSuggestions || ticketSuggestions.length === 0 || selectedTravellerCategory === TravellerCategory.unknown) return undefined;
  return ticketSuggestions
    .filter(
      (ticket) => ticket.productType === ProductType.singleTicket && ticket.travellerCategory === selectedTravellerCategory && TicketSuggestionHelper.hasValidSalesChannelsAndTimeLimitation(ticket)
    )
    .sort((a, b) => a.priceInSek - b.priceInSek)[0];
}

function Prices({ journey, journeyDetails }: { journey: IJourney; journeyDetails?: IJourneyDetails }) {
  // === STATE ===
  const [selectedTravellerCategory, setSelectedTravellerCategory] = useState<TravellerCategory>(TravellerCategory.adult);

  // === VARIABLES ===
  const collapsibleId = IdHelper.newUniqueId('collapsible-area-');
  const destinationLinkTransportMode = journey.destinationLink?.transportMode;
  const cheapestSingleTicket = getCheapestSingleTicket(journeyDetails?.ticketSuggestions, selectedTravellerCategory);

  return (
    <div className={`journey-details-map-prices bg-gray`}>
      <button
        type="button"
        className="journey-details-map-prices__collapse-button btn--unstyled w-100 d-flex align-items-center justify-content-between fw-bold collapsed"
        data-bs-toggle="collapse"
        data-bs-target={`#${collapsibleId}`}
        aria-expanded="false"
        aria-controls={collapsibleId}
        aria-live="polite"
        onClick={() => AnalyticsService.addEvent(AnalyticsService.TravelPlannerCategory, 'Visa biljettinformation', '')}
      >
        <span className="d-flex align-items-center">
          <span className="text-break text-start">{TranslationService.get('travelplanner.tickets')}</span>
          {journeyDetails?.ticketSuggestions && journeyDetails?.ticketSuggestions?.length > 0 && <ZoneIcon className="ms-2" tariffZones={journeyDetails.tariffZones} journey={journey}></ZoneIcon>}
        </span>
        {cheapestSingleTicket && (
          <span className="ms-2 text-nowrap fw-normal">
            {TranslationService.get('common.from')} {cheapestSingleTicket.priceInSek} kr
          </span>
        )}
      </button>
      <div className="px-3 collapse" id={collapsibleId}>
        <div className="pb-3">
          {journeyDetails?.ticketSuggestions && destinationLinkTransportMode === undefined && (
            <TicketSuggestions ticketSuggestions={journeyDetails?.ticketSuggestions} onTravellerCategoryChange={setSelectedTravellerCategory}></TicketSuggestions>
          )}
          {journeyDetails?.ticketSuggestions && destinationLinkTransportMode !== undefined && (
            <div className="text-center p-3">
              {destinationLinkTransportMode === TransportMode.walk && <span>{TranslationService.get('travelplanner.walkjourneypricetext')}</span>}
              {destinationLinkTransportMode === TransportMode.bike && <span>{TranslationService.get('travelplanner.bikejourneypricetext')}</span>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Prices;
